<footer class="footer ">
    <div class="container">
        <!-- Left: Logo -->
        <div class="footer-logo">
            <img src="images/icons/tab-icon.svg" alt="Technozone Logo">
        </div>
        <div class="footer-container">
    
            <!-- Middle: Links -->
            <div class="footer-links">
                <span>© {{ currentYear }}, {{ 'Technozone' | translate}} </span>
                <a [href]=" global.languageCode + '/privacy-and-policy' "> {{ 'PrivacyPolicy' | translate}} </a>
                <a [href]=" global.languageCode + '/terms-and-conditions' "> {{ 'TermsAConditions' | translate}} </a>
            </div>
    
            <!-- Right: Social icons -->
            <div class="footer-socials">
                <a href="#"> <img src="images/icons/facebook.svg" alt=""> </a>
                <a href="#"> <img src="images/icons/x.png" alt=""> </a>
                <a href="#"> <img src="images/icons/instagram.svg" alt=""> </a>
                <a href="#"> <img src="images/icons/linkedIn.svg" alt=""> </a>
            </div>
        </div> 
    </div>
</footer> 